import { useEffect, type ReactNode } from 'react';

/**
 * Generic modal using the prototype's ported classes (.modal-back / .modal)
 * and its dismiss behaviour: clicking the backdrop closes (index.html:731).
 * Escape-to-close is added — the prototype had no keyboard dismiss, which is
 * an a11y gap rather than a design decision.
 */
export function Modal({
  onClose,
  label,
  children,
  wide = false,
}: {
  onClose: () => void;
  label: string;
  children: ReactNode;
  wide?: boolean;
}) {
  useEffect(() => {
    function onEsc(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [onClose]);

  return (
    <div className="modal-back open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-label={label}
        style={wide ? { maxWidth: 760 } : undefined}
      >
        {children}
      </div>
    </div>
  );
}
